export default "__VITE_ASSET__DntOJBXN__"